import { getStatsigEnvTier } from '../session/session'
import { ENVIRONMENT, postToStatsig, USER_ID } from './statsig-client'

export const logEvent = ({
  eventName,
  value,
  metadata,
}: {
  eventName: string
  value?: string | number | null
  metadata?: Record<string, string> | null
}) => {
  const env = getStatsigEnvTier()

  const payload = {
    events: [
      {
        user: {
          statsigEnvironment: ENVIRONMENT[env],
          userID: USER_ID,
        },
        time: Date.now(),
        eventName,
        metadata,
        value,
      },
    ],
  }

  return postToStatsig('/v1/log_event', payload)
}
